import { Canvas } from "@react-three/fiber";
import "./App.css";
import { Model } from "./Components/Model";
import {
  Environment,
  OrbitControls,
  PerspectiveCamera,
} from "@react-three/drei";
import { Suspense } from "react";
import Logo from "./Icons/Logo";

function App() {
  return (
    <div className="h-screen flex flex-col items-center justify-center bg-gradient-to-r from-orange-50 via-orange-100 to-orange-50">
      <div className="pt-12">
        <div className="text-gray-700 hover:text-orange-400 hover:scale-95 duration-200">
          <a href="https://www.obytes.com/">
            <Logo />
          </a>
        </div>
      </div>

      <Canvas
        camera={{
          position: [0, 50, 100],
        }}
      >
        <ambientLight intensity={1.2} />
        <Environment preset="city" />
        <Suspense fallback={null}>
          <Model />
        </Suspense>
        <OrbitControls />
      </Canvas>

      <div className="text-gray-700 text-xs font-extralight pb-8">
        Made by{" "}
        <a
          href="https://twitter.com/OuhraOmar"
          className="font-medium  hover:text-orange-400  duration-200 "
        >
          Omar Ouhra
        </a>
      </div>
    </div>
  );
}

export default App;
